import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-arthauptgrp-list-view',
  imports: [],
  templateUrl: './arthauptgrp.list-view.html',
  styleUrls: ['./arthauptgrp.list-view.css'],
})
export class ArthauptgrpListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
